/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAvailableAssetCategoriesResponse = {
  success?: true | undefined;
  data: Array<string>;
};

/** @internal */
export const GetAvailableAssetCategoriesResponse$inboundSchema: z.ZodType<
  GetAvailableAssetCategoriesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  success: z.literal(true).default(true).optional(),
  data: z.array(z.string()),
});

/** @internal */
export type GetAvailableAssetCategoriesResponse$Outbound = {
  success: true;
  data: Array<string>;
};

/** @internal */
export const GetAvailableAssetCategoriesResponse$outboundSchema: z.ZodType<
  GetAvailableAssetCategoriesResponse$Outbound,
  z.ZodTypeDef,
  GetAvailableAssetCategoriesResponse
> = z.object({
  success: z.literal(true).default(true as const),
  data: z.array(z.string()),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetAvailableAssetCategoriesResponse$ {
  /** @deprecated use `GetAvailableAssetCategoriesResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetAvailableAssetCategoriesResponse$inboundSchema;
  /** @deprecated use `GetAvailableAssetCategoriesResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetAvailableAssetCategoriesResponse$outboundSchema;
  /** @deprecated use `GetAvailableAssetCategoriesResponse$Outbound` instead. */
  export type Outbound = GetAvailableAssetCategoriesResponse$Outbound;
}

export function getAvailableAssetCategoriesResponseToJSON(
  getAvailableAssetCategoriesResponse: GetAvailableAssetCategoriesResponse,
): string {
  return JSON.stringify(
    GetAvailableAssetCategoriesResponse$outboundSchema.parse(
      getAvailableAssetCategoriesResponse,
    ),
  );
}

export function getAvailableAssetCategoriesResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetAvailableAssetCategoriesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetAvailableAssetCategoriesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAvailableAssetCategoriesResponse' from JSON`,
  );
}
